import React from 'react';
import { Star, Quote } from 'lucide-react';
import { scrollToSection } from '../utils/navigation';

const Temoignages = () => {
  const testimonials = [
    {
      name: "Faim2pates",
      role: "Blogueur culinaire",
      image: "./images/chef_formation_5.jpeg",
      rating: 5,
      text: "J'ai passé un agréable moment en compagnie de ce passionné de pizza qui a pris la peine de me donner plein d'astuces pour une cuisson dans le four d'une cuisine classique. Le soir même j'ai préparé 5 pizzas pour le dîner et mon critique gastronomique (Madame Faim2pates) a été bluffé.",
      location: "Région PACA"
    },
    {
      name: "Stagiaire Facebook",
      role: "Participant formation",
      image: "./images/chef_formation_2.jpeg",
      rating: 5,
      text: "Belle formation chez Ecole Niçoise de Pizzaïolo - Ecole de la Pizza Italienne avec M. Jeff Cardone. Création de la pâte, étalage, four, mise en conditions... Merci pour l'accueil, la transmission du savoir-faire !",
      location: "Vallauris"
    },
    {
      name: "Ancien élève",
      role: "Pizzaïolo professionnel",
      image: "./images/chef_formation_1.jpeg",
      rating: 5,
      text: "1er jour de formation à Ecole Niçoise de Pizzaïolo avec M. CARDONE. Merci pour l'accueil, la transmission du savoir-faire. Formation très enrichissante et accessible. Joseph maîtrise parfaitement les traditions italiennes.",
      location: "Antibes"
    }
  ];

  const stats = [
    { number: "500+", label: "Élèves formés" },
    { number: "99%", label: "Taux de réussite" },
    { number: "95%", label: "Satisfaction" },
    { number: "80%", label: "Trouvent un emploi" }
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Témoignages de nos Élèves
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Découvrez les success stories de nos anciens élèves qui ont transformé leur passion en réussite professionnelle.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-yellow-400 mb-2">{stat.number}</div>
              <div className="text-gray-300">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-800 rounded-2xl p-8 relative">
              <Quote className="h-8 w-8 text-yellow-400 mb-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-sm text-gray-400">{testimonial.role}</div>
                  <div className="text-sm text-yellow-400">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Success Stories */}
        <div className="bg-gradient-to-r from-red-600 to-red-800 rounded-2xl p-8 text-center">
          <h3 className="text-3xl font-bold mb-4">Rejoignez nos Success Stories</h3>
          <p className="text-xl text-red-100 mb-6 max-w-2xl mx-auto">
            Nos anciens élèves ont ouvert plus de 150 pizzerias à travers la France. 
            Votre succès commence ici !
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('expert-napolitaine')}
              className="bg-yellow-400 text-red-900 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-300 transition-colors"
            >
              Voir la Formation Expert
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors"
            >
              Nous Contacter
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Temoignages;